// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#doses .dose-marker {
  margin: 0.4rem auto 0;
  padding: 0.15rem 0.6rem;
  text-align: center;
  font-size: 0.8rem;
  color: var(--header-color);
  border: 1.5px solid var(--main-foreground-color);
  border-radius: 999px;
  width: fit-content;
}

#doses .dose-entry + .dose-marker {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/entries/DoseMarker.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,gDAAgD;EAChD,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["#doses .dose-marker {\n  margin: 0.4rem auto 0;\n  padding: 0.15rem 0.6rem;\n  text-align: center;\n  font-size: 0.8rem;\n  color: var(--header-color);\n  border: 1.5px solid var(--main-foreground-color);\n  border-radius: 999px;\n  width: fit-content;\n}\n\n#doses .dose-entry + .dose-marker {\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
